module.exports = __webpack_public_path__ + "static/media/search-event-flower.51cac7ad.png";